(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sid-cotton-purchase"] && !Shopify.designMode) return;
  try {
    async function refreshCottonThrowPurchases() {
  const cards = document.querySelectorAll('[data-cotton-throw-purchase]');
  if (!cards.length) return;
  try {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(root + 'collections/cotton-throws/products.json?limit=250');
    if (!response.ok) return;
    const {products} = await response.json();
    const catalogue = new Map(products.map(product => [product.handle, product]));
    const currency = window.Shopify?.currency?.active || 'EUR';
    const money = new Intl.NumberFormat(document.documentElement.lang || 'en-IE', {style: 'currency', currency});
    cards.forEach(card => {
      const product = catalogue.get(card.dataset.cottonThrowPurchase);
      const input = card.querySelector('[name="id"]');
      const variant = product?.variants.find(variant => String(variant.id) === input.value);
      if (!variant) return;
      const description = card.querySelector('[data-cotton-throw-description]');
      if (description && product.body_html) description.innerHTML = product.body_html;
      card.querySelector('.sid-gallery-purchase__price').textContent = money.format(Number(variant.price));
      const button = card.querySelector('button');
      button.disabled = !variant.available;
      button.textContent = variant.available ? button.dataset.addLabel : button.dataset.soldLabel;
    });
  } catch {}
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', refreshCottonThrowPurchases, {once: true});
} else {
  refreshCottonThrowPurchases();
}
document.addEventListener('shopify:section:load', refreshCottonThrowPurchases);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sid-lighting-catalogue"] && !Shopify.designMode) return;
  try {
    (function(){
  function galleryState(gallery){
    const track=gallery.querySelector('[data-gallery-track]');
    const count=track.children.length;
    const index=Math.max(0,Math.min(count-1,Math.round(track.scrollLeft/Math.max(1,track.clientWidth))));
    return {track:track,count:count,index:index};
  }
  function updateGallery(gallery){
    const state=galleryState(gallery);
    const position=gallery.querySelector('[data-gallery-position]');
    if(position)position.textContent=(state.index+1)+' / '+state.count;
    gallery.querySelectorAll('[data-gallery-index]').forEach(function(button){
      if(Number(button.dataset.galleryIndex)===state.index)button.setAttribute('aria-current','true');
      else button.removeAttribute('aria-current');
    });
    const previous=gallery.querySelector('[data-gallery-step="-1"]');
    const next=gallery.querySelector('[data-gallery-step="1"]');
    if(previous)previous.disabled=state.index===0;
    if(next)next.disabled=state.index===state.count-1;
  }
  function moveGallery(gallery,index){
    const state=galleryState(gallery);
    const target=Math.max(0,Math.min(state.count-1,index));
    const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    state.track.scrollTo({left:target*state.track.clientWidth,behavior:reduced?'auto':'smooth'});
  }
  document.addEventListener('click',function(event){
    const button=event.target.closest('[data-gallery-index],[data-gallery-step]');
    if(!button)return;
    const gallery=button.closest('[data-lighting-gallery]');
    if(!gallery)return;
    const state=galleryState(gallery);
    moveGallery(gallery,button.hasAttribute('data-gallery-index')?Number(button.dataset.galleryIndex):state.index+Number(button.dataset.galleryStep));
  });
  document.addEventListener('scroll',function(event){
    if(!event.target.matches||!event.target.matches('[data-gallery-track]'))return;
    const gallery=event.target.closest('[data-lighting-gallery]');
    window.requestAnimationFrame(function(){updateGallery(gallery);});
  },true);
  document.addEventListener('keydown',function(event){
    if(!event.target.matches('[data-gallery-track]'))return;
    const gallery=event.target.closest('[data-lighting-gallery]');
    const state=galleryState(gallery);
    let index;
    if(event.key==='ArrowRight')index=state.index+1;
    else if(event.key==='ArrowLeft')index=state.index-1;
    else if(event.key==='Home')index=0;
    else if(event.key==='End')index=state.count-1;
    else return;
    event.preventDefault();moveGallery(gallery,index);
  });

  function closeLightingDetails(dialog){
    const state=dialog.lightingState;
    if(!state)return;
    state.visualMarker.replaceWith(state.visual);
    state.details.hidden=true;
    state.detailsMarker.replaceWith(state.details);
    dialog.querySelector('[data-lighting-dialog-copy]').replaceChildren();
    dialog.lightingState=null;
    window.requestAnimationFrame(function(){
      state.visual.querySelector('[data-gallery-track]').scrollLeft=state.index*state.visual.querySelector('[data-gallery-track]').clientWidth;
      updateGallery(state.visual);
      state.opener.focus({preventScroll:true});
    });
  }
  document.addEventListener('click',function(event){
    const close=event.target.closest('[data-lighting-close]');
    if(close){close.closest('dialog').close();return;}
    const opener=event.target.closest('[data-lighting-open]');
    if(!opener||opener.closest('dialog'))return;
    const card=opener.closest('.sl-catalogue-card');
    const dialog=card.closest('.sl-catalogue').querySelector('.sl-product-dialog');
    const visual=card.querySelector('[data-lighting-gallery]');
    const details=card.querySelector('[data-lighting-details]');
    const state=galleryState(visual);
    const visualMarker=document.createComment('lighting-visual');
    const detailsMarker=document.createComment('lighting-details');
    visual.before(visualMarker);details.before(detailsMarker);
    dialog.lightingState={visual:visual,details:details,visualMarker:visualMarker,detailsMarker:detailsMarker,index:state.index,opener:opener};
    dialog.querySelector('[data-lighting-dialog-title]').textContent=card.querySelector('.sl-catalogue-info h2').textContent;
    const copy=dialog.querySelector('[data-lighting-dialog-copy]');
    copy.replaceChildren(card.querySelector('.sl-catalogue-price').cloneNode(true));
    details.hidden=false;copy.append(details);
    dialog.querySelector('[data-lighting-dialog-visual]').append(visual);
    dialog.showModal();
    window.requestAnimationFrame(function(){state.track.scrollLeft=0;updateGallery(visual);});
  });
  document.addEventListener('close',function(event){
    if(event.target.matches('.sl-product-dialog'))closeLightingDetails(event.target);
  },true);
  document.addEventListener('click',function(event){
    if(event.target.matches('.sl-product-dialog'))event.target.close();
  });

  document.addEventListener('change',function(event){
    const select=event.target.closest('[data-lighting-variant]');
    if(!select)return;
    document.querySelectorAll('[data-lighting-price="'+select.dataset.lightingVariant+'"]').forEach(function(price){price.textContent=select.selectedOptions[0].dataset.price;});
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sid-quilt-purchase"] && !Shopify.designMode) return;
  try {
    async function refreshQuiltPurchases() {
  const cards = document.querySelectorAll('[data-quilt-purchase]');
  if (!cards.length) return;
  try {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(root + 'collections/hand-block-print-quilts/products.json?limit=250');
    if (!response.ok) return;
    const {products} = await response.json();
    const catalogue = new Map(products.map(product => [product.handle, product]));
    const currency = window.Shopify?.currency?.active || 'EUR';
    const money = new Intl.NumberFormat(document.documentElement.lang || 'en-IE', {style: 'currency', currency});
    cards.forEach(card => {
      const product = catalogue.get(card.dataset.quiltPurchase);
      const input = card.querySelector('[name="id"]');
      const variant = product?.variants.find(variant => String(variant.id) === input.value);
      if (!variant) return;
      const description = card.querySelector('[data-quilt-description]');
      if (description && product.body_html) description.innerHTML = product.body_html;
      card.querySelector('.sid-gallery-purchase__price').textContent = money.format(Number(variant.price));
      const button = card.querySelector('button');
      button.disabled = !variant.available;
      button.textContent = variant.available ? button.dataset.addLabel : button.dataset.soldLabel;
    });
  } catch {}
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', refreshQuiltPurchases, {once: true});
} else {
  refreshQuiltPurchases();
}
document.addEventListener('shopify:section:load', refreshQuiltPurchases);
  } catch(e) { console.error(e); }
})();

})();
